import {useState, createContext, useContext, useEffect} from 'react';

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({children}) => {
    const persisted = localStorage.getItem('ui') ? JSON.parse(localStorage.getItem('ui')) : null;

    // PANEL JEST ZAWSZE JASNY. Decyzja właściciela z 08.09.2026, ta sama na
    // stronie fleetify.pl i tutaj.
    //
    // Wcześniej motyw szedł za ustawieniem systemu — i to z odwróconym
    // warunkiem: `matchMedia('(prefers-color-scheme: light)')` dawało 'dark',
    // czyli człowiek z jasnym systemem dostawał ciemny panel. Do tego Panel v2
    // ma tokeny --pv2-* wyłącznie w wersji jasnej (baza.scss maluje tło na
    // twarde #fafafa), więc w motywie ciemnym zmienne starego motywu robiły
    // się białe na jasnym tle: napisy znikały.
    //
    // `setTheme` zostaje w kontekście, żeby nie wywracać składników, które go
    // czytają. Nikt go dziś nie woła — przełącznika motywu w interfejsie nie ma.
    const [theme, setTheme] = useState('light');
    const [fontScale, setFontScale] = useState(persisted !== null ? persisted.scale : 1);

    const page =  document.documentElement;

    useEffect(() => {
        localStorage.setItem('ui', JSON.stringify({theme: theme, scale: fontScale}));
        page.style.setProperty('--font-scale', fontScale);
        page.classList.add('no-transition');
        setTimeout(() => document.documentElement.classList.remove('no-transition'), 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme, fontScale]);

    return (
        <ThemeContext.Provider value={{theme, setTheme, fontScale, setFontScale}}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useThemeProvider = () => useContext(ThemeContext);